/* eslint-disable import/prefer-default-export */
import React from 'react';
import useSubscription from '../Subscription/useSubscription';
import styles from './navigation.module.css';

const noRender = (): JSX.Element => <></>;

function CompanyLogo(): React.ReactElement {
    const { getOrganizationLogoUrl } = useSubscription();
    const url = getOrganizationLogoUrl();
    return url ? (
        <div className={styles.CompanyLogoContainer}>
            <img className={styles.CompanyLogo} src={url} alt="Current Logged In Company Logo" />
        </div>
    ) : (
        noRender()
    );
}
export default CompanyLogo;
